function buocCaiDat() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Cài đặt",
      content:
        "Trang này gồm 2 nhóm khác nhau: tuỳ chọn RIÊNG cho máy/trình duyệt đang dùng (không đồng bộ sang máy khác), và quy tắc sinh mã áp dụng cho TOÀN HỆ THỐNG (ảnh hưởng mọi người dùng).",
    },
    {
      target: "#tour-cai-dat-qr",
      title: "Bước 2 · Kích thước QR khi tải xuống",
      content:
        "Cỡ tem QR mặc định chỉ áp dụng cho máy/trình duyệt đang dùng (lưu local), không ảnh hưởng người khác. Ảnh QR luôn là hình vuông — số nhập vào là kích thước thật khi in ra dán, ví dụ nhập 4 nghĩa là in ra tem 4 × 4 cm.",
      placement: "bottom",
    },
    {
      target: "#tour-cai-dat-quy-tac",
      title: "Bước 3 · Quy tắc sinh mã chủ vườn",
      content:
        "Đặt mẫu mã riêng cho Chủ vườn thường và Nhân viên nội bộ (chọn khi tạo chủ vườn ở form), dùng placeholder {tinh}/{xa}/{stt}. Đổi quy tắc chỉ ảnh hưởng tới mã MỚI sinh sau khi lưu — KHÔNG tự đổi mã đã cấp cho chủ vườn cũ, nên đổi xong không cần lo in lại QR cũ.",
      placement: "top",
    },
    {
      target: "#tour-cai-dat-nguy-hiem",
      title: "Bước 4 · Cảnh báo — không thể hoàn tác",
      content:
        "Nút này tạo lại mã cho TOÀN BỘ chủ vườn hiện có theo quy tắc hiện hành, kể cả người đã có mã từ trước. Mọi mã QR đã in dán ngoài thực địa sẽ không còn khớp với mã hiển thị trong hệ thống sau khi đổi — chỉ bấm khi chắc chắn sẽ in lại toàn bộ mã QR chủ vườn.",
      placement: "top",
    },
  ];
}

export default buocCaiDat;
